import React from 'react'
import styled, { css } from 'styled-components'

const ContainerWrapper = styled.div`
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin: 0 auto;
    @media (min-width: 576px) {
        max-width: 100%;
    }
    @media (min-width: 768px) {
        max-width: 720px;
    }
    @media (min-width: 992px) {
        max-width: 960px;
    }
    @media (min-width: 1200px) {
        max-width: 1170px;
    }

    a.mute {
        text-decoration: none;
        transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    }
    a.highlight {
        color: text-red;
        background-color: #ffffff;
        border-radius: 8px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    }
    .highlight {
        background-color: #ffffff;
        border-radius: 8px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    }
`

const Container = ({ children, ...props }) => {
    return <ContainerWrapper {...props}>{children}</ContainerWrapper>
}

export default Container
